<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import OrderEmailSettings from './OrderEmailSettings.vue';
  import { IBranch } from '../../../interfaces/IBranch';
  import OrderEmailSent from './OrderEmailSent.vue';
  @Component({
    components: { OrderEmailSent, OrderEmailSettings },
  })
  export default class OrderEmail extends Vue {
    @Prop() branch: IBranch;
    tabIndex = 0;

    async created() {}
  }
</script>

<template>
  <v-layout class="order-email-container">
    <v-container>
      <v-card>
        <v-card-title> Envío de emails </v-card-title>
        <v-card-text>
          <v-tabs v-model="tabIndex">
            <v-tab>Mails enviados</v-tab>
            <v-tab>Configuración </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabIndex">
            <v-tab-item class="pt-4">
              <OrderEmailSent :branch="branch" />
            </v-tab-item>
            <v-tab-item class="pt-4">
              <OrderEmailSettings :branch="branch" />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<style scoped lang="scss"></style>
